const locale = require('./gridTotals.i18n.json');

/*@ngInject*/
const GridTotalsController = function () {

    this.$onInit = function () {
        this.i18n = locale;
    };

    this.getValue = function (column) {
        return this.totalData[column._accessor];
    };
};

angular.module('gw-um-submission').controller('gridTotalsController', GridTotalsController);
